<template>
  <div id="app">
    <sidebar v-if="userLogged" @open="openSidebar = $event" />
    <main
      class="main-content"
      :class="{ logged: userLogged, open: openSidebar }"
    >
      <NavBar v-if="userLogged" />
      <router-view />
    </main>
  </div>
</template>

<script>
import { mapState } from "vuex";

// Components
import NavBar from "@/components/layout/NavBar";
import Sidebar from "@/components/layout/Sidebar";

export default {
  components: { Sidebar, NavBar },
  data() {
    return {
      openSidebar: false
    };
  },
  computed: {
    ...mapState({
      userLogged: "user"
    })
  }
};
</script>

<style lang="scss">
@import "src/assets/sass/styles";
#app {
  position: relative;
  font-family: $font-main;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $grey-white-color;
  background: $grey-white-color;
  font-size: 1rem;
  height: 100vh;
  overflow-y: auto;
  .main-content {
    width: auto;
    height: 100%;
    overflow-x: hidden;
    &.logged {
      height: auto;
      padding: 0px 35px 100px 36px;
      border-left: 126px solid white;
    }
  }
}

@media (max-width: 768px) {
  #app {
    .main-content {
      &.logged {
        transition: 0.6s;
        padding: 0px 30px 100px 30px;
        border-left: none;
      }
      &.open {
        transition: 0.6s;
        padding: 0px 30px 100px 30px;
        border-left: 80px solid white;
      }
    }
  }
}
</style>
